import React from 'react';
import { Typography } from '@mui/material';
import './PlansGrid.css';
import DoneIcon from '@mui/icons-material/Done';
import { useNavigate } from 'react-router-dom';

const PlansGrid = () => {
  const navigate = useNavigate();
  const plans = [
    {
      title: "Student",
      price: "Free",
      description: "Join your classes and access assessments provided by your teacher.",
      features: [
        "Join unlimited classes",
        "Take assessments",
        "Receive personalized feedback"
      ],
      buttonLabel: "Sign Up for Free",
      color: "var(--primary-purple)",
      popular: false,
    },
    {
      title: "Family",
      price: "AED 300 / month",
      yearlyDiscount: "25% off for yearly plans",
      description: "Track and support your children's education with AI-powered tools.",
      features: [
        "Up to 8 students",
        "Unlimited assessments",
        "Track children's progress",
        "a dedicated support person available to help you",
        "Personalized experience",
        "Auto-renewed (cancel anytime)"
      ],
      buttonLabel: "Get Started",
      color: "var(--dark-purple)",
      popular: true, // let's highlight this plan
    },
    {
      title: "Teacher",
      price: "AED 300 / month",
      yearlyDiscount: "25% off for yearly plans",
      description: "Empower your teaching with AI tools to personalize student learning.",
      features: [
        "Up to 360 students",
        "Create classes to organize students",
        "Unlimited assessments",
        "Personalized experience",
        "Auto-renewed (cancel anytime)"
      ],
      buttonLabel: "Get Started",
      color: "var(--sky-blue)",
      popular: false,
    },
    {
      title: "School",
      price: "Custom Pricing",
      description: "Custom plans tailored to your institution's needs.",
      features: [
        "Unlimited teachers and students",
        "Admin dashboard",
        "Personalized support",
        "Custom assessments",
        "Advanced analytics"
      ],
      buttonLabel: "Request a Quote",
      color: "var(--mock-purple)",
      popular: false,
    },
  ];

  return (
    <div className="plans-grid">
      {plans.map((plan, index) => (
        <div 
          key={index} 
          className={`plan-card ${plan.popular ? 'popular-plan' : ''}`}
        >
          {/* Optional Badge for popular plan */}
          {/* {plan.popular && (
            <div className="popular-badge">
              <Typography variant="caption">Most Popular</Typography>
            </div>
          )} */}

          {/* Card Header with background or gradient */}
          <div 
            className="card-header" 
            
          >
            <Typography variant="h5" className="grid-plan-title" style={{ color: plan.color }}>
              {plan.title}
            </Typography>
          </div>

          {/* Card Body */}
          <div className="card-body">
            <Typography variant="h6" className="plan-price">
              {plan.price}
            </Typography>
            {plan.yearlyDiscount && (
              <Typography variant="body2" className="plan-discount">
                {plan.yearlyDiscount}
              </Typography>
            )}
            <Typography variant="body1" className="plan-description">
              {plan.description}
            </Typography>
            <ul className="plan-features">
              {plan.features.map((feature, i) => (
                <li key={i} className="plan-feature-item">
                  <DoneIcon className="feature-icon" />
                  {feature}
                </li>
              ))}
            </ul>
          </div>

          {/* Card Footer */}
          <div className="card-footer">
            <button
              className="plan-button"
              style={{ background: plan.color }}
              onClick={() => {
                navigate('/auth');
              }}
            >
              {plan.buttonLabel}
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PlansGrid;
